// CommunicationOverview.jsx
import React from "react";
import styles from "./CommunicationOverview.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import { FiEdit2 } from "react-icons/fi";
import { HiOutlineDocumentText } from "react-icons/hi2";

const communicationData = [
  { label: "Email", count: 20, color: "#f8bcbc" },
  { label: "Texts", count: 30, color: "#c5c8ff" },
  { label: "Messages", count: 40, color: "#aee1c9" },
];

const total = communicationData.reduce((sum, item) => sum + item.count, 0);

const CommunicationOverview = () => {
  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <HeadingAndIcon
          icon={<HiOutlineDocumentText />}
          heading="Communication over view"
        />
        <div className={styles.editWrapper}>
          <FiEdit2 size={16} /> <span>This Month</span>
        </div>
      </div>

      <div className={styles.graphWrapper}>
        <svg viewBox="0 0 36 36" className={styles.donut}>
          {
            communicationData.reduce(
              (acc, item, index) => {
                const prev = acc.offset;
                const val = (item.count / total) * 100;
                acc.offset += val;
                acc.segments.push(
                  <circle
                    key={item.label}
                    className={styles.segment}
                    r="15.9155"
                    cx="18"
                    cy="18"
                    fill="transparent"
                    stroke={item.color}
                    strokeWidth="4"
                    strokeDasharray={`${val} ${100 - val}`}
                    strokeDashoffset={100 - prev}
                  />
                );
                return acc;
              },
              { offset: 0, segments: [] }
            ).segments
          }
        </svg>

        <div className={styles.valueLabels}>
          {communicationData.map((item, index) => (
            <div
              key={item.label}
              className={styles.valueLabel}
              style={{ color: item.color }}
            >
              <span className={styles.count}>{item.count}</span>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.legend}>
        {communicationData.map((item) => (
          <div className={styles.dotRow} key={item.label}>
            <span
              className={styles.dot}
              style={{ backgroundColor: item.color }}
            ></span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommunicationOverview;
